<template>
  <div class="simple-table-wrapper">
    <table class="simple-table">
      <thead>
        <tr>
          <th
            v-for="column in columns"
            :key="column.key"
            :style="{ width: column.width ? column.width + 'px' : 'auto', textAlign: column.align || 'left' }"
            @click="column.sortBy && onSort(column)"
          >
            {{ column.title }}
            <span v-if="column.sortBy && sortKey === column.key" class="sort-indicator">
              <span v-if="sortOrder === 'asc'">v</span>
              <span v-else>^</span>
            </span>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(row, rowIndex) in tableData" :key="rowIndex">
          <td
            v-for="column in columns"
            :key="column.key"
            :style="{ width: column.width ? column.width + 'px' : 'auto', textAlign: column.align || 'left' }"
          >
            <component
              v-if="column.renderBodyCell"
              :is="createCell(column, row, rowIndex)"
            />
            <span v-else>
              {{ row[column.field] }}
            </span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { h } from 'vue';

export default {
  name: 'SimpleTable',
  props: {
    columns: {
      type: Array,
      required: true
    },
    tableData: {
      type: Array,
      required: true
    },
    sortOption: {
      type: Object,
      default: () => ({})
    }
  },
  emits: ['sort'],
  data() {
    return {
      sortKey: null,
      sortOrder: 'asc'
    };
  },
  methods: {
    createCell(column, row, rowIndex) {
      if (column.renderBodyCell) {
        try {
          const result = column.renderBodyCell({ row, column, rowIndex }, h);
          if (result && typeof result === 'object' && result.type) {
            return result;
          }
          return h('span', {}, result);
        } catch (err) {
          console.error('Error rendering cell:', err);
          return h('span', {}, String(row[column.field] || ''));
        }
      }
      return h('span', {}, String(row[column.field] || ''));
    },
    onSort(column) {
      if (column.sortBy) {
        if (this.sortKey === column.key) {
          this.sortOrder = this.sortOrder === 'asc' ? 'desc' : 'asc';
        } else {
          this.sortKey = column.key;
          this.sortOrder = 'asc';
        }
        if (this.sortOption.sortChange) {
          this.sortOption.sortChange({
            key: column.key,
            order: this.sortOrder
          });
        }
      }
    }
  }
};
</script>

<style>
.simple-table-wrapper {
  width: 100%;
  overflow-x: auto;
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

.simple-table {
  width: 100%;
  border-collapse: collapse;
  background-color: #fff;
  table-layout: auto;
}

.simple-table thead {
  background-color: #f5f5f5;
  font-weight: bold;
  position: sticky;
  top: 0;
  z-index: 10;
}

.simple-table th,
.simple-table td {
  padding: 12px;
  border: 1px solid #ddd;
  text-align: left;
  vertical-align: middle;
  word-break: break-word;
}

.simple-table th {
  cursor: pointer;
  user-select: none;
  white-space: normal;
}

.simple-table th:hover {
  background-color: #efefef;
}

.simple-table tbody tr:hover {
  background-color: #f9f9f9;
}

.simple-table tbody tr:nth-child(odd) {
  background-color: #fafafa;
}

.sort-indicator {
  margin-left: 5px;
  font-size: 12px;
}
</style>


